import React from "react";
import PropTypes from "prop-types";
import AppDialog from "./AppDialog";
import { Box, Container, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
export default function AppDialogHalfScreen({
  title = null,
  subtitle = null,
  component = null,
  note = null,
  icon = null,
  show = false,
  setShow = () => { },
  centralize = false,
  children
}) {
  const isLargeScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const { t } = useTranslation();
  const onChangeShow = (val) => {
    if (setShow && typeof setShow === "function") setShow(val);
  };
  const isLargeScreenOrCentralized = (isLargeScreen || centralize)
  return (
    <AppDialog
      show={show}
      showClose={false}
      fullScreen={false}
      onChangeShow={onChangeShow}
      sx={{
        ".MuiDialog-paper": {
          height: "auto",
          position: isLargeScreenOrCentralized ? "relative" : "fixed",
          bottom: 0,
          margin: isLargeScreenOrCentralized ? "24px" : 0,
          borderRadius: isLargeScreenOrCentralized
            ? "8px 8px 8px 8px"
            : "8px 8px 0px 0px",
        },
      }}
    >
      <Container maxWidth="xs" sx={{ padding: 2 }} disableGutters>
        <Box
          display={"flex"}
          justifyContent="center"
          alignItems={"center"}
          flexDirection="column"
        >
          {icon && icon}
          {!!title && (
            <Typography
              color="#D4D4D8"
              fontSize={15}
              fontWeight={700}
              textAlign="center"
              marginTop={2}
              fontFamily={"Manrope"}
            >
              {title}
            </Typography>
          )}
          {!!subtitle && (
            <Typography
              color="#D4D4D8"
              fontSize={14}
              fontWeight={400}
              textAlign="center"
              marginTop={2}
              fontFamily={"Manrope"}
            >
              {subtitle}
            </Typography>
          )}
          {note && (
            <Typography
              color="#D4D4D8"
              fontSize={14}
              fontWeight={700}
              textAlign="center"
              marginTop={2}
              fontFamily={"Manrope"}
            >
              {t("note")}: {note}
            </Typography>
          )}
        </Box>
        {!!component && (
          <Box
            color="#F8F8F8"
            fontSize={16}
            marginTop={4}
            display="flex"
            justifyContent={"center"}
            fontFamily={"Manrope"}
          >
            {component}
          </Box>
        )}
        {children}
      </Container>
    </AppDialog>
  );
}
AppDialogHalfScreen.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  component: PropTypes.any,
  icon: PropTypes.any,
  show: PropTypes.bool,
  setShow: PropTypes.func,
  note: PropTypes.string,
};
